import { render, staticRenderFns } from "./SegmentListCreateOrEditCategoriesFilter.vue?vue&type=template&id=26e4d8d2&scoped=true&"
import script from "./SegmentListCreateOrEditCategoriesFilter.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditCategoriesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e4d8d2",
  null
  
)

export default component.exports